import { render, staticRenderFns } from "./SuccessLogin.vue?vue&type=template&id=5a2be043&"
import script from "./SuccessLogin.vue?vue&type=script&lang=js&"
export * from "./SuccessLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports